// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__111NH","label":"Labeled_label__1y6LJ","divider":"Labeled_divider__3QUuB"};